import { resourceSliceFactory } from "infrastructure/store/state";
import type { OnboardingState } from "./types";

const state: OnboardingState = resourceSliceFactory();

export const sliceToken = 'onboarding';

export default state;
